@if (steps) {
    <div class="tabs is-toggle is-fullwidth">
        <ul>
            @for (step of steps; track step) {
                <li class="is-active" [ngClass]="{'is-active': step.active }" (click)="selectTab(step)">
                    <a>
                        <span>{{ step.description }}</span>
                        <span class="icon is-small">
                            @if(!step.completed){
                                <fa-icon [icon]="faCircle"></fa-icon>
                            } @else {
                                <fa-icon [icon]="faCircleCheck"></fa-icon>
                            }
                        </span>
                    </a>
                </li>
            }
        </ul>
    </div>
}